import React, {memo, forwardRef, useEffect, useRef } from 'react';

const Nudge = forwardRef((props, ref) => { 
  
  return(
    <div ref={ref} className={`TopNudge ${props.speed} OverflowHidden TransitionEastOut`}></div>
  )
});

export default Nudge;